module.exports = __webpack_public_path__ + "img/gongzuotai_active.eb359ef6.png";